import { useContext, useEffect } from 'react';
import AuthService from '../../../Services/Authentication/AuthService';
import LocalStorageService from '../../../Services/LocalStorageService';
import { VoidReturn } from '../../../Utils/PageUtils';
import { MainViewContext } from '../MainView/MainViewContext';
import { TransitionAction } from '../MainView/MainViewModel';
import { useNavigate } from 'react-router-dom';

export type WelcomeHandler = {
    onContinue: () => VoidReturn;
};

function useWelcomeHandler(): WelcomeHandler {
    const navigate = useNavigate();
    const viewContext = useContext(MainViewContext);

    const loading = async () => {
        const patientId = LocalStorageService.serviceInstance.getPatientId();
        if (patientId === '') {
            const refreshCookies = async () => {
                await AuthService.adB2cInstance.refreshCookies();
            };
            refreshCookies();
        }
    };

    useEffect(() => {
        loading();
    }, [navigate]);

    const onContinue = async () => {
        viewContext.doTransition(TransitionAction.WelcomeContinue);
    };

    return {
        onContinue,
    };
}

export default useWelcomeHandler;
